/**
 * Personal: the two pages that are about the signed-in person rather than the
 * workspace - their notification rules and their own profile.
 */
export default ({ t, accountScopedRoute }) => ({
  name: 'Settings Personal',
  label: t('SIDEBAR.SETTINGS_GROUP_PERSONAL'),
  icon: 'i-ph-user-circle',
  defaultFolded: true,
  children: [
    {
      name: 'Settings Notifications',
      label: t('SIDEBAR.NOTIFICATIONS'),
      icon: 'i-ph-bell',
      to: accountScopedRoute('notifications_settings_index'),
    },
    {
      name: 'Settings Profile',
      label: t('SIDEBAR.PROFILE'),
      icon: 'i-ph-identification-badge',
      activeOn: ['profile_settings', 'profile_settings_mfa'],
      to: accountScopedRoute('profile_settings_index'),
    },
  ],
});
